export const isElementVisible = (element) => {
  if (element) {
      // Check Visibility by using style property as pre-requisite, and if it is false then don't execute the isElementFullyVisible method.
      if(!isElementVisibleByStyles(element)) return false
      if(isElementInVisible(element)) return false
  }
  return true
}

const isElementVisibleByStyles = (element) => {
  const styles = window.getComputedStyle(element)
  return styles.visibility !== 'hidden' && styles.display !== 'none'
}
/**
* Returns whether element is visible or not by checking all the four corners of an
* element visibilty.
* @param {*} element 
* @returns 
*/
const isElementInVisible = (element) => {
  const boundingRect = element.getBoundingClientRect(); // Get the Boundaries of a passed element
  // Get the top, right, left and bottom pixels and add/substract one pixel to avoid the borders.
  const left = boundingRect.left + 1
  const right = boundingRect.right - 1
  const top = boundingRect.top + 1
  const bottom = boundingRect.bottom - 1
  
  // Use elementFromPoint method of document object to identify which element is visible at the location
  // and if it matches with the element passed then it is visible and returns false, else invisible and return true
  if(document.elementFromPoint(left, top) !== element) return true
  if(document.elementFromPoint(right, top) !== element) return true
  if(document.elementFromPoint(left, bottom) !== element) return true
  if(document.elementFromPoint(right, bottom) !== element) return true
  
  return false
}